import { useMemo } from "react";
import { Alert } from "react-bootstrap";
import { Cart } from "../../types/Cart";
import "./ExportPreview.scss";
import { FieldAvailable } from "./get-fields-available";
import MaskedFieldValue from "./MaskedFieldValue";

interface ExportPreviewProps {
  columns: FieldAvailable[];
  rows: Cart["items"];
}

const ExportPreview: React.FC<ExportPreviewProps> = ({ columns, rows }) => {
  const bodyRows = useMemo(() => {
    return rows.map((row, index) => (
      <tr key={row.id}>
        {columns.map((column) => {
          let cellContents: string | React.ReactNode = "";
          const investor = row.searchableInvestorEntry;
          if (typeof column.underlyingField === "function") {
            const underlyingVal = column.underlyingField(investor, null, index);
            if (typeof underlyingVal === "string") {
              cellContents = underlyingVal;
            } else {
              cellContents = <MaskedFieldValue field={underlyingVal.field} />;
            }
          } else {
            cellContents = "<preview unavailable>";
          }
          return <td key={column.name}>{cellContents}</td>;
        })}
      </tr>
    ));
  }, [columns, rows]);

  return (
    <div className="export-preview">
      <div className="export-builder-header">Export Preview</div>
      <div className="export-preview-content">
        {columns.length > 0 ? (
          <table className="table table-bordered">
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={column.name}>{column.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>{bodyRows}</tbody>
          </table>
        ) : (
          <Alert variant="info">
            No columns selected. Please select at least one column to export.
          </Alert>
        )}
      </div>
    </div>
  );
};

export default ExportPreview;
